var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCircleGauge = function SvgCircleGauge(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.204 3.15121C15.7087 2.18181 12.956 2.10001 10.4075 2.91953C7.85911 3.73906 5.67002 5.41006 4.20752 7.65221C2.74502 9.89436 2.09807 12.5713 2.37521 15.2338C2.65234 17.8964 3.8367 20.3827 5.72961 22.2756C7.62251 24.1685 10.1088 25.3529 12.7714 25.63C15.434 25.9072 18.1109 25.2602 20.353 23.7977C22.5952 22.3352 24.2662 20.1461 25.0857 17.5977C25.9052 15.0492 25.8234 12.2965 24.854 9.80121",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0052 16.3327C15.2939 16.3327 16.3385 15.288 16.3385 13.9993C16.3385 12.7107 15.2939 11.666 14.0052 11.666C12.7165 11.666 11.6719 12.7107 11.6719 13.9993C11.6719 15.288 12.7165 16.3327 14.0052 16.3327Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6328 12.3673L22.1661 5.83398",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCircleGauge;